import { CompactTable } from '@table-library/react-table-library/compact';
import { useTheme } from '@table-library/react-table-library/theme';
import { getTheme } from '@table-library/react-table-library/baseline';
import { usePagination } from "@table-library/react-table-library/pagination";

import Styles from './users.module.scss'
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiEye, FiSearch, FiUsers } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { getUsersList } from "../../store/user/userActions";
import { getImage } from "../../utils";
import PhoneInput from "react-phone-input-2";
import countriesMask from "../../utils/data/phoneMasks.json"
import { TablePagination } from "../../components/global/table-pagination";
import { ProfileRole } from "../../store/profile/profileSlice";

const UsersList = () => {
    const [search, setSearch] = useState("");

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    const [nodes, setNodes] = useState([]);
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getUsersList())
        .unwrap()
        .then(v => setNodes(v))
    }, [])

    const COLUMNS = [
        {
            onHeaderCell: {
                maxWidth: "50px"
            },
            label: 'Avatar', class: "avatar", renderCell: (item) => {
                return <img className={Styles.avatar} src={getImage(item.avatar, "AVATAR")} />
            },
        },
        {
            label: 'Firstname',
            renderCell: (item) => item.firstName
        },
        {
            label: 'Lastname',
            renderCell: (item) => item.lastName,
        },
        {
            label: 'Email',
            renderCell: (item) => item.email
        },
        {
            label: 'Phone',
            renderCell: (item) => (item.phone && item.phone?.trim() != "") ?<PhoneInput
            disabled={true}
            masks={countriesMask}
            value={item.phone}
            dropdownStyle= {{display: "none"}}
            inputStyle={{border:0, paddingLeft:0, cursor: "default"}}
            buttonClass="hidden"
            countryCodeEditable={false}
            onChange={phone => this.setState({ phone })}
          /> : ""
        },
        {
            label: 'Country', renderCell: (item) => {
                return <img src={`https://flagsapi.com/${item.country}/shiny/24.png`} />
            },
        },
        {
            label: 'Profile', renderCell: (item, index) => {
                return(
                    <div className={Styles.profileList}>
                        {item.profiles.map((profile, i) => {
                            return  profile.role === ProfileRole.TUTOR ? 
                            <span className={`${Styles.profile} ${Styles.tutor}`}>Tutor</span> : 
                            profile.role === ProfileRole.STUDENT ? <span className={`${Styles.profile} ${Styles.student}`}>Student</span> : ""
                        })}
                    </div>
                )
            }
        },
        {
            label: '',
            renderCell: (item, index) => {
                return <Link className={Styles.viewBtn} to={`/users/user/${item._id}`}>
                    <FiEye />
                    <span>View</span>
                </Link>
            }
        },
    ];


    const theme = useTheme([getTheme(), {
        HeaderRow: `color: #191D51;`,
        HeaderCell: `width: auto;`,
        Cell:  `width: auto;`,
    }]);

    let data = { nodes };

    data = {
        nodes: data.nodes.filter((item) =>
            item.firstName.toLowerCase().includes(search.toLowerCase()) ||
            item.lastName.toLowerCase().includes(search.toLowerCase()) ||
            item.email.toLowerCase().includes(search.toLowerCase()) ||
            (item.phone && item.phone.toLowerCase().includes(search.toLowerCase()))
        ),
    };

    const pagination = usePagination(data, {
        state: {
            page: 0,
            size: 5,
        }
    });
    const pageButtonCount = 2;
    const totalPages = pagination.state.getTotalPages(data.nodes)
    const pages = pagination.state.getPages(data.nodes);

    return (
        <div className={Styles.tableContainer}>
            <div className="mb-5 rounded-2xl border border-slate-200 bg-slate-50 p-4 sm:p-5">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex items-center gap-3">
                        <div className="grid h-10 w-10 place-items-center rounded-xl bg-nt-blue/10 text-nt-blue">
                            <FiUsers size={18} />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-nt-blue">Users</h2>
                            <p className="text-sm text-nt-grey">Browse and manage all platform users</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <p className="text-sm text-nt-grey">
                    {data.nodes.length} result{data.nodes.length === 1 ? "" : "s"}
                </p>
                <label htmlFor="search" className="relative w-full sm:w-[300px]">
                    <FiSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-nt-grey" size={16} />
                    <input
                        id="search"
                        type="text"
                        placeholder="Search users..."
                        className="w-full rounded-lg border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm outline-none transition focus:border-nt-blue focus:ring-2 focus:ring-nt-blue/10"
                        value={search}
                        onChange={handleSearch}
                    />
                </label>
            </div>

            <CompactTable columns={COLUMNS} data={data} theme={theme} pagination={pagination} key={"_id"} />
            
            {totalPages > 0 ? <TablePagination
                pageButtonCount={pageButtonCount}
                totalPages={totalPages}
                pagination={pagination}
                pages={pages}
            /> : null}
        </div>

    )
}

export { UsersList }